import React from "react";
import { TableContext, useTable } from "@hook";
import { PageTemplate } from "@component";
import { TagStatisticsContainer } from "@container";
import moment from "moment";

const TagStatistics = () => {
  const tableState = useTable({
    initial: {
      fromDateTime: moment().subtract(7, "days"),
      searchTypes: {
        condition: 'POSITIVE'
      }
    }
  })
  return (
    <TableContext.Provider value={tableState}>
      <PageTemplate>
        <TagStatisticsContainer />
      </PageTemplate>
    </TableContext.Provider>
  )
}

export default TagStatistics
